<template>
    <div>
        <router-view>
        </router-view>
    </div>
</template>

<script>
    export default {
        name: "LandingView",
    };
</script>

<style scoped>

</style>
